<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Geehr0/tc-custom/9781783408566.jpg?1720021246390" alt="This image is the cover for the book Skelmanthorpe, Clayton West & District"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skelmanthorpe, Clayton West & District
      </h1>
      <p class="bookDescription body article font2">
        <p>Utilising the very best archive photographs that have survived the ravages of time, Ye Olde Townships is a unique record of the changing face of the district. This book provides an historical window into the landscape and lives of the people who created the villages we know today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Heath
      </h2>
      
      <p class="authorDescription body article">Chris Heath is an author and local historian.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?674e3233